export const NOT_APPLICABLE_SYMBOL = "–"; // this is an en-dash!!! (not a hyphen)
